import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const openProfileMenu = createAsyncThunk(
  'dropdownMenu',
  (menu) => {
    return menu;
  }
);

const initialState = {
  openMenu: false,
}

const menuReducer = createSlice({
  name: 'menu',
  initialState,
  reducers: {},
  extraReducers:(builder) => {
    builder
    .addCase(openProfileMenu.pending, (state) => {
      state.openMenu = false;
    })
    .addCase(openProfileMenu.fulfilled, (state, action) => {
      state.openMenu = action.payload ? action.payload : false
    })
    .addCase(openProfileMenu.rejected, (state, action) => {
      state.openMenu = action.payload ? action.payload : false
    })
  },
})

export default menuReducer.reducer
